import * as types from './constants';

// Get Performance Snapshot
export const getPerformanceSnapshotRequest = data => (
  { type: types.GET_PERFORMANCE_SNAPSHOT_REQUEST, payload: data }
);

export const getPerformanceSnapshotDone = data => (
  { type: types.GET_PERFORMANCE_SNAPSHOT_DONE, payload: data }
);

export const getPerformanceSnapshotFailed = errors => (
  { type: types.GET_PERFORMANCE_SNAPSHOT_FAILED, payload: errors }
);

export const getPerformanceSnapshotReset = data => (
  { type: types.GET_PERFORMANCE_SNAPSHOT_RESET, payload: data }
);